import {    CARGAR_FACTURAS_FECHA, CARGAR_DEVOLUCIONES_FECHA,CARGAR_DESCUENTOS_FECHA,CARGAR_PROFORMAS_FECHA,CARGAR_PEDIDO_PROCESO_FECHA,CARGAR_ARTICULOS_FECHA } from '../actions/vendedores/actionTypes';

const vendedoresReducer = (state = {
facturas: [],
devoluciones:[],
descuentos:[],
proformas:[],
pedidoProcesos:[],
articulosPedido:[]
}, action) => {
    switch(action.type){
    case CARGAR_FACTURAS_FECHA:
        return { ...state, facturas: action.data };
    case CARGAR_DEVOLUCIONES_FECHA:
        return { ...state, devoluciones: action.data };
    case CARGAR_DESCUENTOS_FECHA:
        return { ...state, descuentos: action.data };
    case CARGAR_PROFORMAS_FECHA:
        return { ...state, proformas: action.data };
    case CARGAR_PEDIDO_PROCESO_FECHA:
        return { ...state, pedidoProcesos: action.data };
    case CARGAR_ARTICULOS_FECHA:
        return { ...state, articulosPedido: action.data };
    default:
        return state;
    }
};


export default vendedoresReducer;